{
  "bodyHelp": "Markdown is supported. Your user name is added automatically.",
  "bodyLabel": "Description",
  "bodyPlaceholder": "What did you do, what happened, and what did you expect?",
  "bodyWithReference": "Reference: {{reference}}\n\n",
  "hint": "Tell the DMW team about an error or something that is hard to use.",
  "menuItem": "Report a problem…",
  "sending": "Sending…",
  "sent": "Thank you. Your report was sent.",
  "submit": "Send report",
  "title": "Report a problem",
  "titleLabel": "Title",
  "titlePlaceholder": "Short summary of the problem"
}
